var map = {
	"./en.json": "5bBP",
	"./ja.json": "XcqD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JQHW";


//////////////////
// WEBPACK FOOTER
// ./src/common/lang ^\.\/.*\.json$
// module id = JQHW
// module chunks = 120